import React, { useCallback, useMemo } from 'react';
import { Box, CIPStatus, Enrollment } from '@common-fe/common-fe';

import routes from '@/common/routes';
import { useHistory } from '@/modules/core/hooks';

import { EnrollmentCardBlock } from './EnrollmentCardBlock';
import { EnrollmentDates } from './EnrollmentDates';
import { Wrapper } from './EnrollmentItem.styles';

interface Props {
  enrollment: Enrollment;
  investingMode?: boolean;
  isDateless?: boolean;
  clickMode?: boolean;
  width?: string | number;
  wrapperStyle?: React.CSSProperties;
}

export const ENROLLMENT_ITEM_WIDTH_S = '336px';
export const ENROLLMENT_ITEM_WIDTH_L = '400px';

const EnrollmentItem: React.FC<Props> = ({
  enrollment,
  investingMode,
  clickMode,
  wrapperStyle,
  width,
  isDateless,
}) => {
  const history = useHistory();

  const isNotVerified = useMemo(
    () =>
      (enrollment?.CIPStatus === CIPStatus.Fail || enrollment?.CIPStatus === CIPStatus.Question) &&
      enrollment.isCIPRequired,
    [enrollment]
  );

  const goToPage = useCallback(
    (path: string) => (event: React.SyntheticEvent) => {
      event.stopPropagation();

      history.push(path);
    },
    [history]
  );
  const handleOpenEnrollmentPage = useCallback(() => {
    if (investingMode || !clickMode) {
      return () => {};
    }

    return goToPage(routes.MY_ACCOUNTS_DETAILS(enrollment.id));
  }, [clickMode, enrollment.id, goToPage, investingMode]);

  return (
    <Box gap="spacing12" style={wrapperStyle || undefined}>
      <Wrapper onClick={handleOpenEnrollmentPage()}>
        <EnrollmentCardBlock
          enrollment={enrollment}
          style={{
            width: width,
            cursor: clickMode ? 'pointer' : 'default',
          }}
        />
        {!isDateless && !isNotVerified && (
          <EnrollmentDates
            coverageDateStart={enrollment.coverageDateStart}
            coverageDateEnd={enrollment.coverageDateEnd}
            submitClaimsDateEnd={enrollment.submitClaimsDateEnd}
            coveragePeriods={enrollment.coveragePeriods}
            width={ENROLLMENT_ITEM_WIDTH_S}
            isRollover={enrollment?.isRollover}
            electionPeriods={enrollment?.electionPeriods}
          />
        )}
      </Wrapper>
    </Box>
  );
};

export default EnrollmentItem;
